import axios from 'axios'
import Qs from 'qs'
import md5 from 'js-md5'
import router from '../../../src/router'
import store from '../../../src/store'

// 发起普通请求，不验证token
let baseRequest = axios.create({});

// 带token的请求，可能导致跨域
let authRequest = axios.create({});

// authRequest请求拦截器
authRequest.interceptors.request.use(
    config => {
      return config;
    },
    err => {
      return Promise.reject(err);
    }
);

// authRequest响应拦截器
authRequest.interceptors.response.use(
    function (response) {

      return responseReturn(response)
    },
    error => {
      return Promise.reject(error);
    }
);

// baseRequest响应拦截器
baseRequest.interceptors.response.use(
    function (response) {
      return responseReturn(response)
    },
    error => {
      return Promise.reject(error);
    }
);

// 处理返回
function responseReturn(response) {
  let res = response.data;

  if (res.code == '0') {
    return res;
  }
  else if (res.code == '105'){
    store.commit('setTokenBe',1);
    router.replace({
      path: '/login'
    });

    return res;
  }
  else if(res.code == '104'){
    store.commit('setTokenBe',1);
    router.replace({
      path: '/login'
    });
    return res;
  }
  else {
    return res;
  }

}

export function sendHttp(obj) {

  let {url, method = 'get', data = null, auth = true} = obj;

  // 时间撮
  let timestamp = (new Date()).getTime();

  let app_secret = "cb933537f8191c33fccc29ffa4433eed";
  let token = window.localStorage.getItem("tokenH");
  // let token = uncompileStr(tokenUuid);

  // 携带默认参数
  data.app_id = "867520190510168";
  data.timestamp = timestamp;

  let weixinOpenid = window.localStorage.getItem("setWapWeixinOpenid");

  // if(weixinOpenid){
  //   data.from = "wap";
  // }
  // else{
  //   data.from = "app";
  // }
  data.from = "partner";

  if(token){
    data.token = token;
  }
  else{
    // data.token = '';
    data.token = 'f453f654c57b04c8d6e37e269d11c68690857766';
    window.localStorage.setItem('tokenH',data.token);
  }

  let arr = [];
  let sign = "";
  for(let i in data){
    arr.push(i +':'+ data[i]);
  }
  sign = arr.sort().join('#');

  data.sign = md5(md5(sign) + app_secret)

  let datas = Qs.stringify(data);

  return new Promise((resolve,reject) => {
    if (auth) {
      authRequest({
        url: url,
        method: method,
        data: datas,
      }).then(res => {
        resolve(res)
      }).catch(error=>{
        reject(error)
      })
    } else {
      baseRequest({
        url: url,
        method: method,
        data: datas,
      }).then(res => {
        resolve(res)
      }).catch(error=>{
        reject(error)
      })
    }
  })

}



